import React, { useState } from 'react';
import { Card, CardBody, Badge, Button, Spinner } from 'reactstrap';
import { Download, Trash2 } from 'react-feather';
import { getAssetId, isImageFile, getFileIconConfig, buildDownloadUrl, buildPreviewUrl } from '../../../../_helper/fileIconHelper';

/**
 * Tek bir dosyayı kart formatında gösterir.
 * - Üstte preview (resimse thumbnail, değilse dosya türü ikonu)
 * - Altında dosya adı + dosya türü badge'i
 * - En altta indir / sil butonları
 */
const FileCard = ({ uploadedFile, typeName, onDownload, onDelete, isDeleting = false }) => {
    const fileName = uploadedFile?.fileName || 'Bilinmeyen Dosya';
    const assetId = getAssetId(uploadedFile);
    const isImage = isImageFile(fileName);
    const iconConfig = getFileIconConfig(fileName);

    const [imgError, setImgError] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const showImagePreview = isImage && assetId && !imgError;

    const { IconComponent, color: iconColor, label: extLabel } = iconConfig;

    const baseOverlayButtonStyle = {
        width: '36px',
        height: '36px',
        padding: 0,
        border: 'none',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
        cursor: 'pointer',
        opacity: 1,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#ffffff'
    };

    const primaryButtonStyle = {
        ...baseOverlayButtonStyle,
        backgroundColor: 'var(--theme-default, #7366ff)'
    };

    const dangerButtonStyle = {
        ...baseOverlayButtonStyle,
        backgroundColor: '#fc4438'
    };

    const disabledStyle = {
        cursor: 'not-allowed',
        opacity: 0.55
    };

    return (
        <Card
            className="h-100 shadow-sm position-relative"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div
                className="position-relative"
                style={{ aspectRatio: '16 / 9', background: '#f8f9fa', overflow: 'hidden' }}
            >
                {showImagePreview ? (
                    <img
                        src={buildPreviewUrl(assetId, 400)}
                        alt={fileName}
                        className="w-100 h-100"
                        style={{ objectFit: 'cover' }}
                        onError={() => setImgError(true)}
                    />
                ) : (
                    <div className="d-flex flex-column align-items-center justify-content-center h-100 gap-2">
                        <IconComponent size={44} color={iconColor} />
                        <span className="text-muted fw-semibold" style={{ letterSpacing: '0.5px', fontSize: '0.8rem' }}>
                            {extLabel}
                        </span>
                    </div>
                )}
            </div>

            <div
                className="position-absolute d-flex gap-1"
                style={{
                    top: '6px',
                    right: '6px',
                    opacity: isHovered ? 1 : 0,
                    pointerEvents: isHovered ? 'auto' : 'none',
                    transition: 'opacity 0.15s ease-in-out',
                    zIndex: 2
                }}
            >
                <button
                    type="button"
                    onClick={onDownload}
                    disabled={!assetId}
                    style={{ ...primaryButtonStyle, ...(!assetId ? disabledStyle : {}) }}
                    title="İndir"
                >
                    <Download size={18} color="#ffffff" />
                </button>
                {onDelete && (
                    <button
                        type="button"
                        onClick={onDelete}
                        disabled={isDeleting}
                        style={{ ...dangerButtonStyle, ...(isDeleting ? disabledStyle : {}) }}
                        title="Sil"
                    >
                        {isDeleting ? <Spinner size="sm" style={{ color: '#ffffff' }} /> : <Trash2 size={18} color="#ffffff" />}
                    </button>
                )}
            </div>

            <CardBody className="d-flex flex-column p-2">
                <div
                    className="fw-semibold mb-1 small"
                    style={{
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        wordBreak: 'break-all',
                        minHeight: '2.4em',
                        lineHeight: '1.2em'
                    }}
                    title={fileName}
                >
                    {fileName}
                </div>
                <div style={{ minWidth: 0 }}>
                    <Badge
                        color="secondary"
                        style={{
                            borderRadius: '6px',
                            padding: '0.3em 0.55em',
                            fontSize: '0.7em',
                            fontWeight: 600,
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            textAlign: 'left',
                            maxWidth: '100%'
                        }}
                    >
                        {typeName || 'Tür Belirsiz'}
                    </Badge>
                </div>
            </CardBody>
        </Card>
    );
};

export default FileCard;
